import React, { useEffect } from 'react';
import Footer from '../components/Footer'; // Adjust the import path as necessary
import HeroBanner from '../components/HeroBanner';
import { FiPhone, FiSend } from 'react-icons/fi';
import { MdShoppingCart } from 'react-icons/md';
import { IoIosClose } from 'react-icons/io';
import { FaBars } from 'react-icons/fa';
import { FaWhatsapp } from 'react-icons/fa';

const Wishlist: React.FC = () => {
  useEffect(() => {
    // Hide loader if present
    const loader = document.getElementById('ftco-loader');
    if (loader) loader.classList.remove('show');
    // Re-initialize AOS and other plugins if available
    if (window.AOS) window.AOS.init();
    const script = document.createElement('script');
    script.src = '/js/main.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="goto-here">
      {/* Top Bar */}
      <div className="py-1 bg-primary w-100">
        <div className="container">
          <div className="row d-flex align-items-center text-white">
            <div className="col-12 col-md d-flex align-items-center mb-1 mb-md-0">
              <FiPhone size={14} className="mr-2" />
              <span>+91 9148761750</span>
            </div>

            <div className="col-12 col-md d-flex align-items-center mb-1 mb-md-0">
              <FiSend size={14} className="mr-2" />
              <span>care@fhome.shop</span>
            </div>

            <div className="col-12 col-md text-md-right">
              <span>3-5 Business days delivery & Free Returns</span>
            </div>
          </div>
        </div>
      </div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar">
        <div className="container">
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img
              src="/images/fhome-logo.jpg"
              alt=""
              style={{ height: "55px", marginRight: "8px", borderRadius: "50%", width: "80px" }}
            />
            <span style={{ fontWeight: 'bold', fontSize: '20px', color: '#28a745' }}></span>
          </a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#ftco-nav" aria-controls="ftco-nav" aria-expanded="false" aria-label="Toggle navigation">
            <FaBars className="mr-2" /> Menu
          </button>
          <div className="collapse navbar-collapse" id="ftco-nav">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item"><a href="/" className="nav-link">Home</a></li>
              <li className="nav-item active dropdown">
                <a className="nav-link dropdown-toggle" href="#" id="dropdown04" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Shop</a>
                <div className="dropdown-menu" aria-labelledby="dropdown04">
                  <a className="dropdown-item" href="/shop">Shop</a>
                </div>
              </li>
              <li className="nav-item"><a href="/about" className="nav-link">About</a></li>
              {/* <li className="nav-item"><a href="/blog" className="nav-link">Blog</a></li> */}
              <li className="nav-item"><a href="/contact" className="nav-link">Contact</a></li>
              <li className="nav-item cta cta-colored"><a href="/cart" className="nav-link"><span><MdShoppingCart size={18} /></span> [0]</a></li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Hero Section */}
      <HeroBanner image="images/fhome-ghee-moonlamp.png">
        <div className="row no-gutters slider-text align-items-center justify-content-center">
          <div className="col-md-9 ftco-animate text-center">
            <p className="breadcrumbs"><span className="mr-2"><a href="/">Home</a></span> <span>Wishlist</span></p>
            <h1 className="mb-0 bread">My Wishlist</h1>
          </div>
        </div>
      </HeroBanner>
      {/* Wishlist Table Section */}
      <section className="ftco-section ftco-cart">
        <div className="container">
          <div className="row">
            <div className="col-md-12 ftco-animate">
              <div className="cart-list">
                <table className="table">
                  <thead className="thead-primary">
                    <tr className="text-center">
                      <th>&nbsp;</th>
                      <th>Product List</th>
                      <th>&nbsp;</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Example rows, repeat as needed for your data */}
                    {[1, 2, 3, 4, 5, 6].map((i) => (
                      <tr className="text-center" key={i}>
                        <td className="product-remove"><a href="#"><span className="ion-ios-close"></span></a></td>
                        <td className="image-prod"><div className="img" style={{ backgroundImage: `url('images/product-${i}.jpg')` }}></div></td>
                        <td className="product-name">
                          <h3>Bell Pepper</h3>
                          <p>F.home - Fresh From Home brings pure, authentic, naturally produced food from farms and local farm communities to every home.</p>
                        </td>
                        <td className="price">₹{i === 1 ? '4.90' : '15.70'}</td>
                        <td className="quantity">
                          <div className="input-group mb-3">
                            <input type="text" name="quantity" className="quantity form-control input-number" defaultValue="1" min={1} max={100} />
                          </div>
                        </td>
                        <td className="total">₹{i === 1 ? '4.90' : '15.70'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Newsletter Section */}
      <section className="ftco-section ftco-no-pt ftco-no-pb py-5 bg-light">
        <div className="container py-4">
          <div className="row d-flex justify-content-center py-5">
            <div className="col-md-6">
              <h2 style={{ fontSize: 22 }} className="mb-0">Subcribe to our Newsletter</h2>
              <span>Get e-mail updates about our latest shops and special offers</span>
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <form action="#" className="subscribe-form">
                <div className="form-group d-flex">
                  <input type="text" className="form-control" placeholder="Enter email address" />
                  <input type="submit" value="Subscribe" className="submit px-3" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* Footer Section */}
      <Footer />
      {/* Loader (optional, can be handled globally) */}
      <div id="ftco-loader" className="show fullscreen"><svg className="circular" width="48px" height="48px"><circle className="path-bg" cx="24" cy="24" r="22" fill="none" strokeWidth={4} stroke="#eeeeee" /><circle className="path" cx="24" cy="24" r="22" fill="none" strokeWidth={4} strokeMiterlimit={10} stroke="#F96D00" /></svg></div>
      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/919148761750"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp size={40} color="#25D366" />
      </a>
    </div>
  );
};

export default Wishlist;

